export default store => {
  return {
    async getTrack(params) {
      return await store.dispatch(`tracks/fetch`, {
        type: "track",
        params
      });
    },
    async getEditingTrack(params) {
      return await store.dispatch(`tracks/fetch`, {
        type: "editing",
        params
      });
    },
    async getTracks(params) {
      return await store.dispatch(`tracks/fetch`, {
        params
      });
    },
    async getReviewTracks(params) {
      return await store.dispatch(`tracks/fetch`, {
        type: "review",
        params
      });
    },
    async getPopularTracks(params) {
      return await store.dispatch("tracks/fetch", {
        type: "popular",
        params
      });
    },
    async getLatestTracks(params) {
      return await store.dispatch("tracks/fetch", {
        type: "latest",
        params
      });
    },
    async getFavoriteTracks(params) {
      return await store.dispatch("tracks/fetch", {
        type: "favorite",
        params
      });
    },
    async getChart(type, params) {
      return await store.dispatch(`tracks/chart`, {
        type,
        params
      });
    }
  };
};
